export default (el) => {
  // See https://selectaccount.atlassian.net/browse/CT-103
  //
  // During table pagination the innerHTML isn't updated before the
  // directive is called. Therefore we delay this code by 0 seconds
  // to put this on the end of the event queue.
  setTimeout(() => {
    let value = parseFloat(el.textContent.replace('$', '').replace(',', '')),
      className = '';

    if (value > 0) {
      className = 'success--text';
      // Have to remove the error class because of element reuse.
      el.classList.remove('error--text');
      el.classList.add(className);
    } else if (value < 0) {
      className = 'error--text';
      // Have to remove the success class because of element reuse.
      el.classList.remove('success--text');
      el.classList.add(className);
    } else {
      el.classList.remove('success--text');
      el.classList.remove('error--text');
    }
  }, 0);
};